(() => {
  if (customElements.get('iy-stock-notice')) return;
  customElements.define('iy-stock-notice', class extends HTMLElement {
    connectedCallback() {
      if (this.sync) return;
      this.form = document.getElementById(this.getAttribute('form-id'));
      if (!this.form) return;
      this.states = JSON.parse(this.querySelector('script').textContent);
      this.sync = () => {
        const state = this.states[this.form.elements.namedItem('id')?.value] || 'unavailable';
        this.querySelectorAll('[data-stock-state]').forEach(panel => { panel.hidden = panel.dataset.stockState !== state; });
        this.querySelector('svg').toggleAttribute('hidden', state !== 'stock');
      };
      this.onChange = event => { if (event.target.name === 'id') this.sync(); };
      this.form.addEventListener('variant:changed', this.sync);
      this.form.addEventListener('change', this.onChange);
      window.addEventListener('pageshow', this.sync);
      this.sync();
    }
    disconnectedCallback() {
      if (!this.sync) return;
      this.form.removeEventListener('variant:changed', this.sync);
      this.form.removeEventListener('change', this.onChange);
      window.removeEventListener('pageshow', this.sync);
      this.sync = null;
    }
  });
})();
